
<template>
    <div>
        <Table
            class="btnAuthTable"
            :table="table"
            @changePage="changePage"
            @changePageSize="changePageSize"
        >
            <template v-slot:operate>
                <a-button v-permission="'setting.sysSetting.addButton'" type="primary" size="small" @click="handle('add')">{{ $t('setting.addButton') }}</a-button>
                <a-divider direction="vertical" />
                <a-button v-permission="'setting.sysSetting.saveSetting'" type="primary" size="small" @click="handle('save')">{{ $t('setting.saveSetting') }}</a-button>
                <!-- <a-divider direction="vertical" />
                <a-button type="primary" size="small" @click="isEdit = true">{{ $t('base.edit') }}</a-button> -->
            </template>

            <!-- 自定义字段 -->
            <template v-slot:btnAuth="{ props }">
                <span 
                    v-for="(item,index) in props.record.auth"
                    :key="index"
                >
                    <a-checkbox 
                        v-if="item"
                        style="margin: 0 10px;width:240px"
                        v-model="item.checked"
                        @change="changeCheck"
                    >
                        {{ item.name }}
                    </a-checkbox>
                </span>
            </template>

            <template v-slot:tableOperate="{ props }">
                <a-button type="primary" size="mini" @click="handle('delete',props.record)">{{ $t('setting.add') }}</a-button>
            </template>
        </Table>

        <!-- 新增按钮 -->
        <a-modal 
            class="addBtn"
            v-model:visible="visible"
            width="55%"
            draggable
            :render-to-body="false"
            :onBeforeOk="onAddBeforeOk"
            @ok="handleAdd"
        >
            <template #title>{{ $t('setting.addButton') }}</template>
            <Form class="addBtnForm" :form="addBtnForm" @handleSelectChange="handleSelectChange"></Form>
        </a-modal>
    </div>
</template>

<script setup>
    import { nextTick, onMounted, reactive, ref, watch } from 'vue';
    import { useRouter } from 'vue-router';
    import { RoleApi } from '@/api/RoleApi.js';
    import { Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import { AddBtnForm } from './queryConfig/SettingForm.js';
    import { useI18n } from 'vue-i18n';
    import { menus } from '@/layout/Menu2';

    const router = useRouter()
    const { t } = useI18n()
    const addBtnForm = reactive(AddBtnForm)
    const visible = ref(false)
    const roleList = ref([])
    const authBtnList = ref([])
    // const isEdit = ref(false)
    const table = ref({
        datas:[],
        columns:[
            {
                title:t('setting.role'), // 角色
                dataIndex: 'roleLabel',
                key:'roleLabel',
                align:'left',
                width:'200',
                ellipsis:true,
                tooltip:true,
            },
            {
                title:t('setting.menu'), // 菜单页面
                dataIndex: 'menu',
                key:'menu',
                align:'left',
                width:'300',
                ellipsis:true,
                tooltip:true,
            },
            {
                title:t('setting.btnAuth'), // 页面按钮
                dataIndex: 'auth',
                key:'auth',
                align:'left',
                slotName:'slot'
            },
        ],
        configs:{
            scroll:{
                // x:1000,
                // y:700,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            dataSpanMethod:({record, column, rowIndex, columnIndex})=>{   
                // console.log({record, column, rowIndex, columnIndex},'22')
                // console.log(firstLevelMenu.value.length,'len')
                const ROWSPAN = firstLevelMenu.value.length - 1 // 一级菜单个数
                console.log(ROWSPAN,'ROWSPAN')
                for(let i=0; i<roleList.value.length; i++){
                    if (record.roleLabel === roleList.value[i].label && rowIndex === i * ROWSPAN && columnIndex === 0) {   
                        return {rowspan: ROWSPAN}
                    }
                }
            },
            pagination:false,
        },
    })
    const firstLevelMenu = ref([])

    const init = ()=>{
        authBtnList.value = []
        for(let i=0;i<roleList.value.length;i++){
            if(roleList.value[i].id != 99){
                getMenuBtnByRole(i+1)
            }
        }
    }

    const initForm = ()=>{
        addBtnForm.formData.menu_type = 'web'
        addBtnForm.formData.menu_category = '2'
    }

    const handle = (type)=>{
        switch(type){
            case 'add':
                visible.value = true
                addBtnForm.formField.forEach(i=>{
                    addBtnForm.formData[i.key] = ''
                })
                initForm()
                break;
            case 'save':
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    hideCancel:false,
                    content: t('setting.saveSettingMsg'),
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        save()
                    }
                });
                break;
        }
    }   
    
    const onAddBeforeOk = ()=>{
        return true
    }

    const changeCheck = (val)=>{
        // console.log(val,'val',authBtnList.value)
    }

    const handleSelectChange = (val,item)=>{
        addBtnForm.formData.menu_parent = 0
        addBtnForm.formData.menu_index = val
    }


    // 获取角色
    const getRoleList = async ()=>{
        let res = await RoleApi.getInstance().getRoleList()
        if(res){
            roleList.value = []
            res.forEach(i=>{
                // if(i.id == 1 || i.id == 2){
                    roleList.value.push({
                        label:i.role_name,
                        value:i.id
                    })
                // }
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取菜单按钮
    const getMenuBtnByRole = async (id)=>{
        table.value.configs.loading = true
        let res = await RoleApi.getInstance().getMenuBtnByRole(id)
        if(res.code == 0){
            let menuList = []
            let btnList = []

            // 按钮项
            res.data.length > 0 && res.data[0].menu && res.data[0].menu.length > 0 && res.data[0].menu.forEach(i=>{
                if(i.menu_category == 2){
                    btnList.push(i)
                }
            })

            // 菜单项
            res.data.length > 0 && res.data[0].menu.forEach(i=>{
                let arr = []
                btnList.map(k=>{
                    if(k.menu_parent == i.menu_parent && k.menu_index == i.menu_index){
                        arr.push(k)
                    }
                })
                if(i.menu_category == 1){
                    menuList.push({
                        role:res.data[0].role.id,
                        menu: t(`${i.menu_name}`),
                        menu_category:i.menu_category,
                        menu_parent:i.menu_parent,
                        menu_index:i.menu_index,
                        child:arr,
                    })
                }
            })
            // console.log(menuList,'menuList')

            menuList.forEach(i => {
                if (i.child.length > 0) {
                    i.child.forEach(k => {
                        authBtnList.value.push({
                            ...i,
                            btn_id: k.id,
                            btn_name: t(k.menu_name),
                            checked: k.exist_flag == undefined? false : k.exist_flag,
                            exist_flag:k.exist_flag, 
                        })
                    })
                }
            })

            getData()
            table.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    const getData = ()=>{
        table.value.datas = []
         roleList.value.forEach(i=>{
            menus.forEach(j=>{
                let arr = []
                authBtnList.value.forEach(k=> {
                    if(k.menu == t(`${j.locale}`) && k.role == i.value){
                        arr.push({
                            name:k.btn_name,
                            checked:k.checked,
                            btn_id: k.btn_id,
                            roleId: k.role,
                            exist_flag:k.exist_flag, 
                        }) 
                    }
                })
                // if(j.key != 'Dashboard'){
                    table.value.datas.push({
                        menu:t(`${j.locale}`),
                        key:i.key,
                        roleValue:i.value,
                        roleLabel:i.label,
                        auth: arr,
                    })     
                // }
            })
        })
    }

    // 确认新增按钮
    const handleAdd = async ()=>{
        let res = await RoleApi.getInstance().addBtn(addBtnForm.formData)
        if(res){
            Message.success(t('base.addSuccess'))
            // init()
            location.reload()
        }else{
            Message.error(res.msg)
        }
    }

    // 保存设置
    const save = async ()=>{
        let arr = [], roleIdArr= []
        table.value.datas.forEach(i=>{
            i.auth.length > 0 && i.auth.forEach(k=>{
                if(k.checked){
                    arr.push({
                        roleId:k.roleId,
                        menuId:k.btn_id,
                    })
                }

                if(!roleIdArr.includes(k.roleId)){
                    roleIdArr.push(k.roleId)
                }
            })
        })
        table.value.configs.loading = true
        let res = await RoleApi.getInstance().roleAuth(arr,roleIdArr.join(','))
        if(res){
            init()
            Modal.warning({
                title: t('base.tip'),
                titleAlign:'start',
                content: t('setting.loginMsg'),
                okText:t('base.ok'),
                onOk:()=>{
                    window.location.reload()
                }
            });
        }else{
            Message.error(res.msg)
        }
    }

    // 获取菜单
    const getMenu = async()=>{
        let res = await RoleApi.getInstance().getMenu()
        if(res.code == 0){
            let item = addBtnForm.formField.find(i=> i.key == 'menu')
            item.options = []
            res.data.forEach(i=>{
                if(i.menu_parent == 0 && i.menu_category == 1){
                    item.options.push({
                        label:t(i.menu_name),
                        value:i.menu_index
                    })
                }
            })
            firstLevelMenu.value = item.options
        }else{
            Message.error(res.msg)
        }
    }

    onMounted(async ()=>{
        await getRoleList()
        getMenu()
        init()
        
    })
</script>

<style lang="less" scoped>
/deep/ .arco-table-th{
    background: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    padding: 3px 0;
    font-weight: 600;
}

/deep/ .arco-table-td{
    padding: 0;
    border-right: 1px solid #eee;
    // border-bottom: none;
}

.addBtnForm{
    /deep/ .arco-input-wrapper,
    /deep/ .arco-form-item-content{
        height: 37px;
        min-height: 37px;
    }

    /deep/ .arco-form > div{
        margin-left: 70px !important;
    }
}

</style>